import { defineStore } from 'pinia'
import type { IGeneralConfigParams } from '@ui/interfaces/generalConfig'
import http from '../helpers/http-call'
import { ENDPOINT_URL, getDataLang, getQuery } from '../helpers/api'

export interface IGeneralConfigQueryProps {
  showData?: boolean
  headers?: {
    Authorization?: string
  }
  hotel_id?: number
  lang_id?: number
  page_size?: number
  page?: number
  group_category?: string
}

const PARAMS: IGeneralConfigQueryProps = {}
export interface IGeneralConfigState {
  general_configs: IGeneralConfigParams[]
  contact_us_general_config: IGeneralConfigParams[]
  loading: boolean
  params: IGeneralConfigQueryProps
  contact_us_general_config: IGeneralConfigParams[]
  loading: boolean
  params: IGeneralConfigQueryProps
}

export const useGeneralConfigStore = defineStore('generalConfig', {
  state: (): IGeneralConfigState => ({
    general_configs: [],
    contact_us_general_config: [],
    loading: false,
    params: PARAMS,
  }),
  actions: {
    async setGeneralConfig(data: IGeneralConfigParams[]) {
      this.general_configs = data
    },
    async setData(query: IGeneralConfigQueryProps) {
      const { headers, group_category, hotel_id, lang_id }: IGeneralConfigQueryProps = query
      const params = getQuery()

      if (group_category) {
        Object.assign(params, {
          group_category,
        })
      }

      if (hotel_id) {
        Object.assign(params, {
          hotel_id,
        })
      }

      if (lang_id) {
        Object.assign(params, {
          lang_id,
        })
      }

      let response: any = {
        data: {},
      }
      if (!this.loading) {
        this.loading = true
        response = await http.call({
          url: `${ENDPOINT_URL}/general-config?hotel_id=${params.hotel_id}&lang_id=${params.lang_id}`,
          headers,
          params,
          method: 'GET',
          data: null,
        })
      }
      this.loading = false

      if (response?.data?.data)
        this.contact_us_general_config = response.data?.data.general_configs
    },
  },
  getters: {
    getGeneralConfig(): IGeneralConfigState['general_configs'] {
      return this.general_configs
    },
  },
})
